import { capitalize, convertRates } from "@/services/utils";
import Company from "@/services/UserService/company";
import ListsService from "@/services/ListsService";
export default class User {
  constructor(features) {
    this.features = features;
  }
  load(json) {
    Object.entries(json).forEach(([key, value]) => {
      this[key] = value;
    });
    this.$original = json;
    this.rateList = convertRates(this.rates);
    if (this.company) {
      // Company is there for /me but not when requesting lists of users
      this.company = new Company().load(this.company);
      if (!this.features) {
        this.features = {};
      }
      if (this.features) {
        _.each(this.features, (value, feature) => {
          this.features[feature] = value;
        });
      }
      _.each(this.terms, (str, term) => {
        this.terms[capitalize(term)] = capitalize(str);
      });
      new ListsService().adjustTerms(this);
      // adjustments are enabled if the feature is enabled -and- it is enabled in the accounts -and- we are pro/trial
      this.adjustments = this.company.settings.adjustments && this.features.writedown;
      this.permissions.charges = this.permissions.charges || {
        assignToCharge: true,
        create: true
      };
      if (this.permissions.charges.create === undefined) {
        this.permissions.charges.create = true;
      }
    }
    this.settings = this.settings || {};
    return this;
  }
  reset(me) {
    return this.load(me.$original);
  }
}